import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
export function ProblemSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full py-0" style={{
    backgroundColor: '#111118'
  }} data-id="element-170">
      <div className="max-w-3xl mx-auto px-5 sm:px-8" data-id="element-171">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} data-id="element-172">
          <p className="text-xs font-semibold tracking-[0.25em] uppercase mb-4" style={{
          color: '#f97316'
        }} data-id="element-173">
            The Problem
          </p>

          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight leading-tight text-white mb-10" data-id="element-174">
            You're a High-Priced Administrator of Your Own Misery.
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 40
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6,
        delay: 0.15,
        ease: 'easeOut'
      }} className="space-y-6" data-id="element-175">
          <p className="text-lg leading-relaxed" style={{
          color: '#d4d4d8'
        }} data-id="element-176">
            Modern corporate culture has a{' '}
            <span className="text-white font-semibold" data-id="element-177">Meeting Addiction</span>.
            We treat calendars like public property. If there's an open slot,
            someone fills it.
          </p>

          <p className="text-lg leading-relaxed" style={{
          color: '#d4d4d8'
        }} data-id="element-178">
            The average professional spends{' '}
            <span className="font-bold" style={{
            color: '#f97316'
          }} data-id="element-179">
              31 hours per week
            </span>{' '}
            in meetings.{' '}
            <span className="font-bold" style={{
            color: '#f97316'
          }} data-id="element-180">
              73%
            </span>{' '}
            of them admit to doing other work during those meetings.
          </p>

          <p className="text-xl font-semibold text-white leading-relaxed" data-id="element-181">
            You're not managing your time. Your calendar is managing you.
          </p>
        </motion.div>

        {/* Accent divider */}
        <motion.div initial={{
        scaleX: 0
      }} animate={isInView ? {
        scaleX: 1
      } : {}} transition={{
        duration: 0.8,
        delay: 0.4,
        ease: 'easeOut'
      }} className="mt-12 h-px w-full origin-left" style={{
        backgroundColor: 'rgba(249, 115, 22, 0.3)'
      }} data-id="element-182" />
      </div>
    </section>;
}